import { View } from '@play-co/timestep-core/ui';
import { AssetGroup } from '@play-co/timestep-core';
import PopupWeeklyLeaderboard from './PopupWeeklyLeaderboard';
import LeaderboardsLineLoginPage from '../components/LeaderboardsLineLoginPage';
import { LeaderboardsNavConfig } from '../components/LeaderboardsNav';
import { Feature } from 'src/replicant/analytics';
import { WeeklyLeaderboardOriginFeature } from 'src/replicant/weeklyLeaderboard/weeklyLeaderboard.analytics.schema';

/**
 * Represents a guest popup for the weekly leaderboard, extending the base `PopupWeeklyLeaderboard`.
 *
 * This class customizes the leaderboard popup for guest users by:
 * - Overriding page creation to always show the login page for all tabs.
 * - Configuring navigation tabs for weekly, friends, and players leaderboards, with tracking metadata.
 * - Setting the default selected tab to "friends".
 * - Providing the asset group for the leaderboard UI.
 *
 * @extends PopupWeeklyLeaderboard
 */
export default class PopupGuestWeeklyLeaderboard extends PopupWeeklyLeaderboard {
  public init({
    originFeature,
  }: {
    originFeature: WeeklyLeaderboardOriginFeature;
  }) {
    super.init({
      selectedTab: 1,
      originFeature,
    });

    this.goToPage('friends');
    this.nav.disabled = true; // Disable navigation for guest users
  }

  protected override createPages(pageView: View) {
    const pages = {
      weekly: () => this.createPage(new LeaderboardsLineLoginPage(pageView)),
      friends: () => this.createPage(new LeaderboardsLineLoginPage(pageView)),
      players: () => this.createPage(new LeaderboardsLineLoginPage(pageView)),
    };

    return pages;
  }

  protected override getNavConfig(): LeaderboardsNavConfig {
    const tabs: LeaderboardsNavConfig['tabs'] = [
      {
        label: 'weeklyLeaderboard.tab_weekly',
        onClick: () => {}, // Do nothing
        tracking: {
          feature: Feature.WEEKLY_LEADERBOARD._,
          $subFeature: Feature.WEEKLY_LEADERBOARD.TAB_WEEKLY,
        },
      },
      {
        label: 'weeklyLeaderboard.tab_friends',
        onClick: () => {}, // Do nothing
        tracking: {
          feature: Feature.WEEKLY_LEADERBOARD._,
          $subFeature: Feature.WEEKLY_LEADERBOARD.TAB_FRIENDS,
        },
      },
      {
        label: 'weeklyLeaderboard.tab_players',
        onClick: () => {}, // Do nothing
        tracking: {
          feature: Feature.WEEKLY_LEADERBOARD._,
          $subFeature: Feature.WEEKLY_LEADERBOARD.TAB_PLAYERS,
        },
      },
    ];
    return {
      tabs,
      selectedIndex: 1, // Default to the friends tab
    };
  }

  protected override getAssetsGroup() {
    return new AssetGroup(
      AssetGroup.constructURLs(['assets/ui/weeklyLeaderboard/']),
    );
  }
}
